export default "__VITE_ASSET__D$JFxygP__"